'use strict';

(function () {
    let map;
    let checked = [];
    let markers = [];
    const allkeys = ['omraden', 'lokaltyp', 'yta', 'arbetsplatser', 'egenskaper'];
    let eventZoomChanged;
    let latestZoomFactor;

    kartor.hamtaSvgRaknare();
    lokalFilter();

    var queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has('karta') && document.getElementById('map')) {
        kartor.initieraKarta(initMap);
    } else {
        kartor.initieraKarta(function () { });
    }

    hanteraFlikKlick();
    filterEvents();

    function addZoomChangeEvent() {
        eventZoomChanged = google.maps.event.addListener(map, 'zoom_changed', function () {
            

            const mapZoom = map.getZoom();
            if (mapZoom > latestZoomFactor && latestZoomFactor <= kartor.zoomLevelForAttVisaAntal && mapZoom > kartor.zoomLevelForAttVisaAntal) {
                updateMarkersOnZoomChange();
            }
            else if (mapZoom < latestZoomFactor && latestZoomFactor > kartor.zoomLevelForAttVisaAntal && mapZoom <= kartor.zoomLevelForAttVisaAntal) {
                updateMarkersOnZoomChange();

            }

            latestZoomFactor = map.getZoom();
        });
    }

    function removeZoomChangeEvent() {
        google.maps.event.removeListener(eventZoomChanged);
    }

    function updateUrlInHistoryForMap() {
        var queryParams = new URLSearchParams(window.location.search);

        if (document.querySelector('.flik-karta').classList.contains('active')) {
            if (!queryParams.has('karta')) {
                queryParams.set('karta', 1);
            }
        } else {
            if (queryParams.has('karta')) {
                queryParams.delete('karta');
            }
        }

        history.replaceState(null, null, '?' + queryParams.toString());
    }

    function lokalFilter() {
        const lokaler = $('.card-lokal');
        const taggdiv = document.getElementById('filter-taggar');
        const antalspan = document.querySelectorAll('.filter-antal span');
        const checkboxes = document.querySelectorAll('.form-check');
        initFilter();

        hanteraCheckboxar();
        visaAntalPerVal();

        function hanteraCheckboxar() {

            checkboxes.forEach(checkbox => {
                const input = checkbox.querySelector('input');
                const label = checkbox.querySelector('label');

                let paramValues = new URLSearchParams(window.location.search).get(input.name);

                if (paramValues) {
                    if (paramValues.split('-').includes(input.value)) {
                        input.checked = true;
                        filtreraLokaler(input, label);
                    }
                }

                input.addEventListener('change',
                    function() {
                        filtreraLokaler(input, label);
                        updateUrlInHistory(input);
                    });

                label.addEventListener('click',
                    function(e) {
                        e.preventDefault();
                        input.checked = !input.checked;
                        input.dispatchEvent(new Event('change'));
                    });
            });
        }
        
        function updateUrlInHistory(input) {
            var queryParams = new URLSearchParams(window.location.search);

            if (input.checked) {
                if (!queryParams.has(input.name)) {
                    queryParams.set(input.name, input.value);
                } else if (!queryParams.get(input.name).split('-').includes(input.value)) {
                    queryParams.set(input.name, queryParams.get(input.name) + '-' + input.value);
                }
            } else {
                if (queryParams.has(input.name)) {
                    let values = queryParams.get(input.name).split('-');

                    var index = values.indexOf(input.value);
                    if (index !== -1) {
                        values.splice(index, 1);
                    }

                    if (values.length === 0) {
                        queryParams.delete(input.name);
                    } else {
                        queryParams.set(input.name, values.join('-'));
                    }
                } 
            }

            history.replaceState(null, null, '?' + queryParams.toString());

            updateUrlInHistoryForMap();
        }

        function filtreraLokaler(input, label) {
            const checkitem = `${input.name}-${input.value}`;


            if (input.checked) {
                if (!checked.includes(checkitem)) {
                    laggTillTagg(label);
                    checked.push(checkitem);
                }
            }
            else {
                taBortTagg(label.htmlFor);
                checked = checked.filter(x => x !== checkitem);
            }

            lokaler
                .addClass('d-none')
            
                .filterByKeys(allkeys)
                .removeClass('d-none');


            visaTotaltAntal();
            visaAntalPerVal(input.name);
            if (map) {
                updateMarkers();
            }
            $('.sidhuvud-slideshow').slick('refresh');
        }

        function laggTillTagg(label) {
            const span = document.createElement('span');

            span.classList.add(label.htmlFor);
            span.innerHTML = label.innerHTML;
            span.addEventListener('click', function () {
                taggKlickad(span);
            });
            taggdiv.append(span);
        }

        function taBortTagg(query) {
            const tagg = taggdiv.querySelector('.' + query);
            if (tagg) {
                tagg.remove();
            }
        }

        function taggKlickad(span) {
            const id = span.classList[0];
            const input = $(`.lokal-filter:not(d-none) #${id}`);

            input.prop('checked', false);
            input[0].dispatchEvent(new Event('change'));
        }

        function visaTotaltAntal() {
            const antal = hamtaValdaLokaler().length;
            antalspan.forEach(span => {
                span.textContent = antal;
            });
        }

        function visaAntalPerVal(name = null) {
            const checkedInputs = document.querySelectorAll(`input[name=${name}]:checked`);
            const valdaLokaler = hamtaValdaLokaler();

            checkboxes.forEach(checkbox => {
                const input = checkbox.querySelector('input');
                const span = checkbox.querySelector('.visa-antal');

                if (!(input.name === name && checkedInputs.length)) {
                    const count = Array.from(valdaLokaler).filter(lokal => {
                        const data = lokal.getAttribute('data-' + input.name);
                        if (input.name === 'egenskaper' || input.name === 'yta' || input.name === 'arbetsplatser') {
                            const datalist = data.split(',');
                            return datalist.indexOf(input.value) > -1;
                        }
                        return data === input.value;
                    }).length;

                    if (span) {
                        span.textContent = `(${count})`;
                    }
                }
            });
        }

        function initFilter() {
            $.fn.filterByKeys = function (keys = allkeys) {
                let filtered = this;

                keys.forEach(key => {

                    filtered = filtered.filterByData(key);
                });
                return filtered;
            };

            $.fn.filterByData = function (key) {
                const checkedList = checked.filter(c => c.indexOf(key) > -1);
                checkedList.forEach(c => {

                });
                return this.filter(function () {
                    if (checkedList.length) {
                        
                        const data = this.getAttribute(`data-${key}`);

                        if (key === 'yta' || key === 'arbetsplatser') {

                            const datalist = data.split(',').map(d => d ? `${key}-${d}` : d);
                            Array.prototype.remove = function () {
                                var rem, a = arguments, L = a.length, ax;
                                while (L && this.length) {
                                    rem = a[--L];
                                    while ((ax = this.indexOf(rem)) !== -1) {
                                        this.splice(ax, 1);
                                    }
                                }
                                return this;
                            };

                            datalist.remove('yta-3');
                            datalist.remove('arbetsplats-3');
                            

                            return checkedList.some(r => datalist.includes(r))

                        }
                        if (key === 'egenskaper' ) {

                            const datalist = data.split(',').map(d => d ? `${key}-${d}` : d);


                            return checkedList.every(c => datalist.indexOf(c) > -1);
                        }

                        return checkedList.indexOf(`${key}-${data}`) > -1;
                    }
                    return true;
                });
            };
        }
    }

    function hamtaValdaLokaler() {
        return document.querySelectorAll('.row-lista .card-lokal:not(.d-none)');
    }

    function hanteraFlikKlick() {
        const flikar = $('.flik');
        const divar = $('.row-lista, .row-karta, .lokal-lista-sida .consent-banner');

        let paramValue = new URLSearchParams(window.location.search).get('karta');

        if (paramValue) {
            flikar.toggleClass('active');
            divar.toggleClass('d-none');
        }

        flikar.on('click', function () {
            if (this.classList.contains('active') === false) {
                flikar.toggleClass('active');
                divar.toggleClass('d-none');
                if (document.querySelector('.row-karta:not(.d-none')) {

                    if (map) {
                        if (map.getZoom() === 0) {
                            updateMarkers(true);
                        }
                        
                    } else {
                        initMap();
                    }
                }
                updateUrlInHistoryForMap();

                $('.sidhuvud-slideshow').slick('refresh');
            }
        });
    }

    function initMap() {
        const lokaler = hamtaValdaLokaler();
        const unikaLokaler = kartor.hamtaUnikaLokaler(lokaler);
        let fitBounds = true;
        if (unikaLokaler.length === 1) {
            map = kartor.skapaKarta(document.getElementById('map'), lokaler[0].dataset.latitud, lokaler[0].dataset.longitud, 16);
            fitBounds = false;
        } else {
            map = kartor.skapaKarta(document.getElementById('map'));
        }

        removeMarkers();

        markers = kartor.markeraLokaler(map, lokaler, markers, fitBounds, kartor.ikonLokalPrimar);
        latestZoomFactor = map.getZoom();
        addZoomChangeEvent();
    }

    

    function updateMarkers() {
        const lokaler = hamtaValdaLokaler();
        let fitbounds = true;
        removeZoomChangeEvent();

        removeMarkers();
        markers = kartor.markeraLokaler(map, lokaler, markers, fitbounds, kartor.ikonLokalPrimar);

        if (markers.length === 1) {

            map.setCenter(new google.maps.LatLng(lokaler[0].dataset.latitud, lokaler[0].dataset.longitud));
            map.setZoom(16);

        }

        addZoomChangeEvent();

        if (latestZoomFactor !== map.getZoom()) {
            updateMarkersOnZoomChange();
            latestZoomFactor = map.getZoom();
        }

    }

    function updateMarkersOnZoomChange() {
        const lokaler = hamtaValdaLokaler();

        removeMarkers();
        markers = kartor.markeraLokaler(map, lokaler, markers, false, kartor.ikonLokalPrimar);
    }

    function removeMarkers() {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers = [];
    }

    function filterEvents() {
        const elements = document.querySelectorAll('[data-dropdown-trigger-event]');

        if (elements.length === 0) return

        const setupTriggers = (el) => {
            const checkboxes = el.nextElementSibling.querySelectorAll('[type="checkbox"]');

            let data = (label) => {
                return {
                    'event': 'Filter',
                    'category': `Filter lediga lokaler - ${el.innerText.toLowerCase()}`,
                    'action': 'Click',
                    'label': `${label}`
                }
            }

            checkboxes.forEach(el2 => {
                el2.addEventListener('change', () => {
                    window._mtm.push(data(el2.nextElementSibling.innerText))
                })
            })
        }

        elements.forEach(setupTriggers)
    }


})();


